<template>
  <DemoViewer :imageSrc="imageUrl" :drag="true" />
  <div class="overlay">
    <div class="carousel-navigation">
      <div class="nav-tabs">
        <button class="nav-tab">
          <span class="tab-label">Click & Drag To Look Around</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import DemoViewer from "./DemoViewer.vue";
const props = defineProps({
  imageUrl: {
    type: String,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  //   background: rgba(0, 0, 0, 0);
  z-index: 2;
}

.carousel-navigation {
  pointer-events: auto;
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;

  @include respond-below(sm) {
    bottom: 1rem;
  }
}
.fit-to {
  margin-top: 0.2rem;
  margin-left: 0.2rem;
  width: fit-content;
}
.nav-tabs {
  display: flex;
  gap: 24px; // Increased gap between tabs (was 16px)
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 0.4rem 1.5rem; // Increased left and right padding (was 0.75rem)
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.3),
    0 1px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 32px;

  &:hover {
    background: rgba(0, 0, 0, 0.55);
    border-color: rgba(255, 255, 255, 0.25);
    box-shadow:
      0 4px 12px rgba(0, 0, 0, 0.4),
      0 2px 6px rgba(0, 0, 0, 0.2);
    transform: translateY(-1px);
  }

  @include respond-below(sm) {
    padding: 0.3rem 1rem; // Increased left and right padding for mobile (was 0.6rem)
    min-height: 28px;
    border-radius: 16px;
    gap: 18px; // Increased gap for mobile (was 12px)
    border: none;
    backdrop-filter: unset;
  }
}

.nav-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  background: transparent;
  text-transform: uppercase;
  border: none;
  border-radius: 0;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem; // Increased from 0.875rem
  font-weight: 400; // Normal weight for non-selected
  line-height: 1.3;
  letter-spacing: 0.025em;
  white-space: nowrap;
  font-family: inherit;
  user-select: none;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);

  &:hover {
    color: rgba(255, 255, 255, 1);
    opacity: 0.8;
  }

  &.active {
    color: rgba(255, 255, 255, 1);
    opacity: 1;
    font-weight: 500; // Bold for selected
    text-decoration: underline; // Underlined for selected
    text-decoration-color: white;
    text-underline-offset: 4px;
    text-decoration-thickness: 1px;
    text-decoration-skip-ink: none;
    // Make underline shorter than the word
    position: relative;
    text-decoration: none; // Remove default underline

    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
      width: 85%; // Underline is 85% of the word width
      height: 0.5px; // Made thinner (was 1px)
      background-color: white;

      @include respond-below(sm) {
        display: none;
      }
    }

    .tab-indicator {
      background: white;
    }
  }

  @include respond-below(sm) {
    font-size: 0.875rem; // Increased from 0.8rem for mobile
    gap: 6px;

    &.active {
      font-weight: 600; // Slightly less bold for mobile
    }

    // .tab-label {
    //   display: none;
    // }
  }

  // @include respond-above(sm) {
  //   .tab-indicator {
  //     display: none;
  //   }
  // }
}
</style>
